import { webInitialization } from 'redux/actions/web'
import { authLogout } from 'redux/actions/auth'
import logo from 'assets/img/brand/logo.svg'
import sygnet from 'assets/img/brand/sygnet.svg'
import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import {
  Badge,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Nav,
  NavItem,
  UncontrolledTooltip,
} from 'reactstrap'
import {
  AppHeaderDropdown,
  AppNavbarBrand,
  AppSidebarToggler,
} from '@coreui/react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import AvatarIcon from 'widgets/elemental/avatar-icon'

const propTypes = {
  dispatch: PropTypes.func,
  id: PropTypes.string,
}
const defaultProps = {}

const linkStyle = {
  textDecoration: 'none',
  color: '#000000',
}
const linkStyleW = {
  textDecoration: 'none',
  color: '#eee',
}
const badgeStyle = {
  position: 'absolute',
  right: 0,
  top: -5,
}
const disabledStyle = {
  display: 'none',
}

class Header extends Component {
  static contextTypes = {
    mqtt: PropTypes.object,
    mqttStatus: PropTypes.string,
  }

  constructor(props) {
    super(props)
    this.state = {
      avatar: 'assets/img/avatars/6.jpg',
      panicscount: 0,
    }
  }

  UNSAFE_componentWillMount() {
    this.props.dispatch(webInitialization())
  }

  newEntriesPrompt = (value) => {
    if (value > 0) {
      return badgeStyle
    } else {
      return disabledStyle
    }
  }

  isOngoingPanic = () => {
    const { actives } = this.props._trackers
    const listItems = actives.list
    let trueCounter = 0
    listItems.forEach((e) => {
      const strKey = e.toString()
      const activeStore = actives.byid[strKey]
      if (activeStore.isPanic === true) {
        trueCounter = trueCounter + 1
      }
    })
    return trueCounter
  }

  onlogout = () => {
    const { mqtt } = this.context
    if (mqtt.connected && !mqtt.disconnecting) {
      mqtt.end()
    }
    this.props.dispatch(authLogout(this.props.token))
  }

  onProfile = () => {
    this.props.history.push('/profile')
  }

  toUsers = () => {
    this.props.history.push('/users')
  }

  render() {
    const currentOrigin = window.location.origin
    const attendanceUrl = new URL(currentOrigin)
    attendanceUrl.hostname = 'hadir.' + attendanceUrl.hostname
    const attendanceBaseUrl = attendanceUrl.toString()

    const reportsNew = this.props._reports_new
    const summonsNew = this.props._summons_new
    const { name, picture } = this.props._user
    const accRole = this.props.auth.info.role
    const profile = this.props.auth.info.profile

    let isPublic = false
    if (profile.email === this.props.dashboardAccount) {
      isPublic = true
    }
    const userRole = accRole.charAt(0).toUpperCase() + accRole.slice(1)
    const panicsCount = this.isOngoingPanic()
    // console.log("Panics Count : ", panicsCount);
    return (
      <React.Fragment>
        <AppSidebarToggler className="d-lg-none" display="md" mobile />
        <AppNavbarBrand
          full={{ src: logo, width: 230, height: 35, alt: 'GuardExpert Logo' }}
          minimized={{
            src: sygnet,
            width: 56,
            height: 35,
            alt: 'GuardExpert Logo',
          }}
        />
        <AppSidebarToggler className="d-md-down-none" display="lg" />

        <Nav className="d-md-down-none" navbar>
          <NavItem className="px-2">
            <Link to="/dashboard" style={linkStyle} className="hover-opa">
              Dashboard
            </Link>
          </NavItem>

          {this.props.auth.info.role !== 'marshal' && !isPublic && (
            <NavItem className="px-2">
              <Link to="/users" style={linkStyle} className="hover-opa">
                Users
              </Link>
            </NavItem>
          )}

          {this.props.auth.info.role !== 'marshal' && !isPublic && (
            <NavItem className="px-2">
              <Link to="/devices" style={linkStyle} className="hover-opa">
                Devices
              </Link>
            </NavItem>
          )}
          {this.props.auth.info.role !== 'marshal' && !isPublic && (
            <NavItem className="px-2">
              <Link to="/zones" style={linkStyle} className="hover-opa">
                Premises
              </Link>
            </NavItem>
          )}
          {this.props.auth.info.role !== 'marshal' &&
            this.props.summon &&
            !isPublic && (
              <NavItem className="px-2">
                <Link to="/offences" style={linkStyle} className="hover-opa">
                  Traffic Offences
                </Link>
              </NavItem>
            )}

          {this.props.attendance && (
            <NavItem className="px-2">
              <a
                href={attendanceBaseUrl}
                rel="noopener noreferrer"
                className="nav-link" // Apply the same class
              >
                Attendance
              </a>
            </NavItem>
          )}
        </Nav>

        <Nav
          className={
            panicsCount > 0
              ? 'ml-auto bg-primary p-2 blink-it radius-30'
              : 'ml-auto'
          }
          navbar
        >
          <span className={panicsCount > 0 ? '' : 'd-none'}>
            <NavItem
              className="d-md-down-none hover-shadow animated fadeIn d-flex d-xl-none"
              id="new_panics_sm"
            >
              <Link to="/panic/ongoing" style={linkStyle} className="m-auto">
                <i className="icon-flag"></i>
                <Badge
                  style={this.newEntriesPrompt(panicsCount)}
                  pill
                  color="danger"
                >
                  {panicsCount}
                </Badge>
              </Link>
            </NavItem>
            <UncontrolledTooltip
              placement="bottom"
              target="new_panics_sm"
              className="animated fadeIn"
            >
              Ongoing Panics
            </UncontrolledTooltip>

            <NavItem
              className="d-md-down-none hover-shadow animated fadeIn d-none d-xl-flex"
              id="new_panics_lg"
            >
              <Link
                className="bg-light-gray radius-30 py-2 pl-3 pr-0"
                to="/panic/ongoing"
                style={linkStyle}
              >
                <span className="text-primary">
                  {panicsCount} Marshals are in Danger!
                </span>{' '}
                <i className="icon-flag rounded-circle bg-white p-3 ml-1"></i>
                <Badge
                  style={this.newEntriesPrompt(panicsCount)}
                  pill
                  color="danger"
                >
                  {panicsCount}
                </Badge>
              </Link>
            </NavItem>
            <UncontrolledTooltip
              placement="bottom"
              target="new_panics_lg"
              className="animated fadeIn"
            >
              Ongoing Panics
            </UncontrolledTooltip>
          </span>

          <NavItem className="d-md-down-none hover-shadow" id="new_reports">
            <Link
              to="/reports/active"
              style={panicsCount > 0 ? linkStyleW : linkStyle}
            >
              <i className="icon-note"></i>
              <Badge
                style={this.newEntriesPrompt(reportsNew)}
                pill
                color="dark"
              >
                {reportsNew}
              </Badge>
            </Link>
          </NavItem>
          <UncontrolledTooltip
            placement="bottom"
            target="new_reports"
            className="animated fadeIn"
          >
            New Reports
          </UncontrolledTooltip>

          {this.props.summon && (
            <React.Fragment>
              <NavItem className="d-md-down-none hover-shadow" id="new_summons">
                <Link
                  to="/traffic/issued"
                  style={panicsCount > 0 ? linkStyleW : linkStyle}
                >
                  <i className="icon-wallet"></i>
                  <Badge
                    style={this.newEntriesPrompt(summonsNew)}
                    pill
                    color="danger"
                  >
                    {summonsNew}
                  </Badge>
                </Link>
              </NavItem>
              <UncontrolledTooltip
                placement="bottom"
                target="new_summons"
                className="animated fadeIn"
              >
                New Compounds
              </UncontrolledTooltip>
            </React.Fragment>
          )}

          <AppHeaderDropdown direction="down">
            <DropdownToggle nav>
              <AvatarIcon filename={picture.filename} />
            </DropdownToggle>
            <DropdownMenu right style={{ right: 'auto' }}>
              <DropdownItem header tag="div" className="text-left">
                <strong>{name}</strong>
                <div className="disabled">
                  {'<'} {userRole} {'>'}
                </div>
              </DropdownItem>
              {this.props.auth.info.role !== 'marshal' && !isPublic && (
                <DropdownItem onClick={this.toUsers}>
                  <Link to="/users" style={linkStyle} className="hover-opa">
                    <i className="fa fa-gear button" /> Users
                  </Link>
                </DropdownItem>
              )}
              <div onClick={this.onProfile}>
                <DropdownItem>
                  <i className="fa fa-user" /> Profile
                </DropdownItem>
              </div>
              <div onClick={this.onlogout}>
                <DropdownItem>
                  <i className="fa fa-lock" /> Logout
                </DropdownItem>
              </div>
            </DropdownMenu>
          </AppHeaderDropdown>
        </Nav>
      </React.Fragment>
    )
  }
}

Header.propTypes = propTypes
Header.defaultProps = defaultProps

const mapStateToProps = (store) => {
  return {
    token: store.auth.info.id,
    auth: store.auth,
    _reports_new: store.reports.reports_new,
    _summons_new: store.summons.summons_new,
    _user: store.endusers.user,
    _trackers: store.trackers,
  }
}

Header.propTypes = {
  dispatch: PropTypes.func,
  token: PropTypes.string,
  auth: PropTypes.object,
  history: PropTypes.object,
  dashboardAccount: PropTypes.string,
  summon: PropTypes.bool,
  attendance: PropTypes.bool,
  _reports_new: PropTypes.number,
  _summons_new: PropTypes.number,
  _user: PropTypes.object,
  _trackers: PropTypes.object,
}

export default connect(mapStateToProps)(Header)
